import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MasterTable } from "../../components/_index";
import { Button, Box } from "@mui/material";
import { getProject } from "../../services/project.service";
import AddIcon from "@mui/icons-material/Add";
import { debounce } from "../../utils/debounce";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const ProjectManagement = () => {
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [tableTotalCount, setTableCount] = useState(0);
  const [queryParam, setQueryParam] = useState({
    search: "",
    page: 1,
    limit: 10,
    sortType: "",
    sort: "",
    month: dayjs().format("MM-YYYY"),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  });
  const GetProjectData = async () => {
    try {
      const res = await getProject(queryParam);
      const modifiedData = res?.data.map((e) => ({
        ...e,
        surveyStartDateMT: e.upComingSurveyDate
          ? dayjs(e.upComingSurveyDate).format("DD/MM/YYYY")
          : "No Survey Date",
      }));
      setTableCount(res?.totalCount || 0);
      setData(modifiedData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    GetProjectData();
  }, [queryParam.search, queryParam.page, queryParam.limit, queryParam.sort, queryParam.month]);

  const columns = [
    { id: "projectName", label: "Project Name" },
    { id: "clientName", label: "Client Name" },
    { id: "projectManagerName", label: "Project Manager" },
    { id: "surveyStartDateMT", label: "Survey Start Date" },
  ];

  const tableOutputEvent = useCallback((params) => {
    setQueryParam((queryParams) => ({
      ...queryParams,
      ...params,
    }));
  }, []);

  const handleAdd = () => {
    navigate("/addProjectManagement", { state: { data: {}, formType: "add" } });
  };
  const handleView = (e) => {
    navigate("/addProjectManagement", { state: { data: e, formType: "view" } });
  };
  const handleEdit = (e) => {
    navigate("/addProjectManagement", { state: { data: e, formType: "edit" } });
  };

  const debouncedHandleSearch = useCallback(
    debounce((searchText) => {
      setQueryParam((queryParams) => ({
        ...queryParams,
        search: searchText,
      }));
    }, 300),
    []
  );

  const handleSearch = (searchText) => {
    debouncedHandleSearch(searchText);
  };

  return (
    <div className="mainContent">
      <Box sx={{ display: "flex", justifyContent: "space-between" }} mb={2}>
        <Box className="SearchInputBoxContainer">
          <SearchOutlinedIcon className="Search_Icon" />
          <input
            className="SearchInputBox"
            placeholder="Search here"
            onChange={(e) => handleSearch(e.target.value)}
          />
        </Box>
        <Box>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DatePicker", "DatePicker"]}>
              <DatePicker
                openTo="month"
                views={["year", "month"]}
                value={dayjs(`${queryParam.month}`, "MM-YYYY")}
                className="datePicker w-100"
                onChange={(e) => {
                  const selectedDate = dayjs(e?.$d);

                  const userTimeZone =
                    Intl.DateTimeFormat().resolvedOptions().timeZone;

                  setQueryParam({
                    ...queryParam,
                    month: selectedDate.format("MM-YYYY"),
                    timezone: userTimeZone,
                  });
                }}
              />
            </DemoContainer>
          </LocalizationProvider>
        </Box>
        {/* <Button className="addButton" onClick={handleAdd}>
          <AddIcon />
          Add Project
        </Button> */}
      </Box>
      <MasterTable
        data={data}
        columns={columns}
        isServerSide={true}
        handleView={handleView}
        // handleEdit={handleEdit}
        tableTotalCount={tableTotalCount}
        tableOutputEvent={tableOutputEvent}
      />
    </div>
  );
};

export default ProjectManagement;
